
<script>
	import {Pie} from 'vue-chartjs'
	export default {
		extends: Pie,
		props: ['data', 'names', 'title'],
		data() {
			return {
				chartData: {
					labels: [],
					datasets: [{
						labels: [],
						backgroundColor: ["#6cb2eb", "#ffed4a", "#f66D9b"],
						data: []
					}]
				}
			}
		},
		mounted() {
			this.chartData.labels = this.names;
			// console.log("pie chart data", this.data, this.names);
			this.names.forEach(key => {
				// console.log("key", this.data[key]);
				if ( this.data.hasOwnProperty(key)) {				
					this.chartData.datasets[0].data.push(parseInt(this.data[key]));
				}
			});		
	
			// console.log("run teacherDistribution", this.chartData);
			let options = {
				// cutoutPercentage: 10,
				// scales: {
				// 	yAxes: [{
				// 		stacked: true
				// 	}]
				// },
				responsive: true,
				 title: {
                    display: true,
                    position: 'top',
                    text: this.title
                }
				// maintainAspectRatio: false
			};
			this.renderChart(this.chartData, options);
		}
	}
</script>
<style scoped>
canvas{
	max-width:350px !important;
	max-height:300px !important;
	text-align: center;
	margin:0 auto;
}
</style>



// WEBPACK FOOTER //
// resources/js/chart/TeacherDistribution.vue